module.exports = __webpack_public_path__ + "img/receive-square-blue.036f0114.svg";